import { Injectable } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root'
})
export class MenuCloseService {
  private menuTriggers: Set<MatMenuTrigger> = new Set();
  private bottomSheetRefs: Set<MatBottomSheetRef<any>> = new Set();

  constructor(private bottomSheet: MatBottomSheet) { }

  /**
   * Registra un MatMenuTrigger per tracciarlo
   */
  registerMenuTrigger(trigger: MatMenuTrigger): void {
    this.menuTriggers.add(trigger);
    
    // Rimuovi il trigger quando il componente viene distrutto
    trigger.menuClosed.subscribe(() => {
      // Opzionale: rimuovi dalla lista quando si chiude naturalmente
    });
  }

  /**
   * Deregistra un MatMenuTrigger
   */
  unregisterMenuTrigger(trigger: MatMenuTrigger): void {
    this.menuTriggers.delete(trigger);
  }

  /**
   * Chiude tutti i menu aperti
   */
  closeAllMenus(): void {
    this.menuTriggers.forEach(trigger => {
      if (trigger.menuOpen) {
        trigger.closeMenu();
      }
    });
  }

  /**
   * Metodo alternativo usando il CDK Overlay
   * Questo metodo è più "globale" e non richiede registrazione
   */
  closeAllMenusViaOverlay(): void {
    // Trova tutti gli overlay aperti e chiudili
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      // Simula un click sul backdrop per chiudere tutti i menu
      const backdrops = overlayContainer.querySelectorAll('.cdk-overlay-backdrop');
      backdrops.forEach((backdrop: any) => {
        backdrop.click();
      });
    }
  }

  /**
   * Metodo più drastico che forza la chiusura di tutti gli overlay
   * Utile quando gli altri metodi non funzionano
   */
  forceCloseAllOverlays(): void {
    // Dispatch di un evento di escape su document
    const escapeEvent = new KeyboardEvent('keydown', {
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      bubbles: true
    });
    document.dispatchEvent(escapeEvent);
  }

  /**
   * Registra un MatBottomSheetRef per tracciarlo
   */
  registerBottomSheet(sheetRef: MatBottomSheetRef<any>): void {
    this.bottomSheetRefs.add(sheetRef);
    
    // Rimuovi il riferimento quando viene chiuso
    sheetRef.afterDismissed().subscribe(() => {
      this.bottomSheetRefs.delete(sheetRef);
    });
  }

  /**
   * Chiude tutti i bottom sheet aperti
   */
  closeAllBottomSheets(): void {
    this.bottomSheetRefs.forEach(sheetRef => {
      sheetRef.dismiss();
    });
    // Pulisci il set dopo aver chiuso tutto
    this.bottomSheetRefs.clear();
  }

  /**
   * Chiude il bottom sheet correntemente aperto (se c'è)
   * Questo metodo non richiede registrazione
   */
  dismissActiveBottomSheet(): void {
    this.bottomSheet.dismiss();
  }

  /**
   * Chiude TUTTO: menu, bottom sheet e altri overlay
   */
  closeAll(): void {
    this.closeAllMenus();
    this.closeAllBottomSheets();
    this.closeAllMenusViaOverlay();
  }
}